import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { ModalOutlet } from '~/application/outlet/ModalOutlet';

const ChangePasswordPage = lazy(() => import('./pages/change-password'));
const DeletePage = lazy(() => import('./pages/delete'));
const EditPage = lazy(() => import('./pages/edit'));
const IndexPage = lazy(() => import('./pages/index'));

export default {
    path: '/users',
    title: 'Korisnici',
    Component: IndexPage,
    children: [{
        Component: ModalOutlet,
        children: [{
            path: 'add',
            Component: EditPage,
        }],
    }, {
        path: ':userId',
        Component: ModalOutlet,
        children: [{
            path: 'change-password',
            Component: ChangePasswordPage,
        }, {
            path: 'delete',
            Component: DeletePage,
        }, {
            path: 'edit',
            Component: EditPage,
        }]
    }],
} satisfies RouteObject;
